<div class="mdc-dialog background" (click)="close()">
    <div class="mdc-dialog__container home-popup-landscape">
        <div class="mdc-dialog__surface close-button-surface">
            <div class="mdc-dialog__surface" [ngClass]="{' before-login': !isLogin,' after-login': isLogin }"
                role="alertdialog">
                <img *ngIf="!isLogin" id="close-button-before" [src]="constants.CLOSE_BUTTON" alt="close-button" />
                <div *ngIf="!isLogin" class="title_container before-title" id="my-dialog-title">
                    WindowSwap<br><b>Version 2.0</b> is here!
                </div>
                <div *ngIf="!isLogin" class="pop-img-container-before">
                    <img src="{{constants.POPUP_BEFOER_HOME_IMG}}" />
                </div>
                <div *ngIf="isLogin" class="pop-img-container">
                    <img class="img-after-login" src="{{constants.POPUP_AFTER_IMG}}" />
                </div>
                <div *ngIf="isLogin" class="title_container after-title" id="my-dialog-title">
                    <h2>{{constants.WELCOME_POPUP_HEADING_AFTER_1_TXT}}<br>{{constants.WELCOME_POPUP_HEADING_AFTER_2_TXT}}
                    </h2>
                </div>
                <div class="mdc-dialog__content description-container" id="my-dialog-content">
                    <div *ngIf="!isLogin">
                        <div class="my-dialog-content"><b>{{constants.WELCOME_POPUP_CONTENT_BEFORE_TXT}}</b></div>
                        <div class="my-dialog-content">{{constants.WELCOME_POPUP_CONTENT_1_BEFORE_TXT}}</div>
                        <div class="my-dialog-content">{{constants.WELCOME_POPUP_CONTENT_2_BEFORE_TXT}}</div>
                        <div class="my-dialog-content">{{constants.WELCOME_POPUP_CONTENT_3_BEFORE_TXT}}</div>
                        <div class="my-dialog-content">{{constants.WELCOME_POPUP_CONTENT_4_BEFORE_TXT}}</div>
                    </div>
                    <br>
                    <div class="description">
                    </div>
                    <div class="mdc-dialog__content buttonContainer" id="my-dialog-content">
                        <button class="popup-button-before"><a *ngIf="!isLogin "
                                [routerLink]="['/signup']">{{constants.SIGNUP_FOR_FREE_TXT}}
                            </a></button>
                        <a *ngIf="isLogin " routerLinkActive="router-link-active">
                            <button (click)="close()" class="popup-button-after">{{constants.GET_STARTED_TXT}}</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>